export const addToCartAction = (data) => {
  return {
    type: "ADD_TO_CART",
    payload: data.length > 0 ? data : [],
  };
};
